module.exports = __webpack_public_path__ + "static/img/qh1-4.badee6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/qh1-4.png
// module id = 908
// module chunks = 0